<script>
    export default {
        name: "WelcomeMixins",
        methods: {
            onClickBack() {
                this.routerManager.back();
            }
        },
    }
</script>